export default {
  getIsFetchedAps: state => state.isFetchedAps,
  getHablilitarAps: state => state.habilitarQuestionarioAps,
  getIdQuestionarioAps: state => state.payloadServidorAps.id,
  getPayloadCliente: state => state.payloadCliente,
  getTemAps: state => state.temAps,
  getPuxarCliente: state => state.puxarCliente,
  getUnimed: state => state.unimed,
  getProntuarios: state => state.listaProntuarios,
  getPayloadServidorAps: state => campo => {
    if (!state.payloadServidorAps) return null;
    if (Object.keys(state.payloadServidorAps).length === 0) return null;

    if (campo) {
      if (!state.payloadServidorAps[campo]) return null;
      if (state.payloadServidorAps[campo].length == 0) return null;
      return state.payloadServidorAps[campo];
    } else {
      return state.payloadServidorAps;
    }
  },
  getDadosUnidades: state => {
    const payloadUnidades = state.payloadServidorAps.unidades;

    if (!payloadUnidades) return null;

    payloadUnidades.forEach(unidade => {
      Object.keys(unidade).forEach(function(key) {
        if (!unidade[key]) {
          unidade[key] = "";
        }
      });
    });

    return payloadUnidades;
  },
  getDadosInfoResponsavel: state => {
    if (!state.payloadServidorAps) return null;

    return {
      nomeUnimed: state.payloadServidorAps.nomeUnimed,
      nomePessoa: state.payloadServidorAps.nomePessoa,
      telefoneNumero: state.payloadServidorAps.telefoneNumero,
      email: state.payloadServidorAps.email,
      cargo: state.payloadServidorAps.cargo,
      dataPreenchimento: state.payloadServidorAps.dataPreenchimento
    };
  },
  getDadosResponsavelAps: state => {
    if (!state.payloadServidorAps) return null;

    return {
      nomeDiretor: state.payloadServidorAps.nomeDiretor,
      emailDiretor: state.payloadServidorAps.emailDiretor
    };
  },
  getDadosRefContraref: state => {
    const payload = state.payloadServidorAps;

    if (!payload) return null;
    if (Object.keys(payload).length == 0) return null;

    const clickSwitches = {
      padraoPreenchimento: payload.padraoPreenchimento,
      informatizadoCompleto: payload.informatizadoCompleto,
      informatizadoParcial: payload.informatizadoParcial,
      manual: payload.manual
    };

    return {
      clickSwitch: {
        ...clickSwitches
      },
      padraoPreenchimentoExclusivo: payload.padraoPreenchimentoExclusivo,
      informatizadoCompletoObs: payload.informatizadoCompletoObs,
      informatizadoParcialObs: payload.informatizadoParcialObs,
      manualExclusivoAps: payload.manualExclusivoAps,
      padraoPreenchimentoObs: payload.padraoPreenchimentoObs
    };
  },
  getDadosProcessosUnidade: state => {
    const payload = state.payloadServidorAps;

    if (!payload) return null;
    if (Object.keys(payload).length == 0) return null;

    const clickSwitches = {
      termoCompromisso: payload.termoCompromisso,
      fluxoAtendimentoExpontaneo: payload.fluxoAtendimentoExpontaneo,
      criteriosCarteiraMedico: payload.criteriosCarteiraMedico,
      criteriosCarteiraEnfermeiro: payload.criteriosCarteiraEnfermeiro,
      pacientesNaoReconhecidos: payload.pacientesNaoReconhecidos,
      existeDescricoesComposicoes: payload.existeDescricoesComposicoes,
      existeProcessoPopulacional: payload.existeProcessoPopulacional,
      temProtocolosClinicos: payload.temProtocolosClinicos,
      reunioesClinicas: payload.reunioesClinicas,
      reunioesAdministrativas: payload.reunioesAdministrativas,
      rotinaMonitoramentoProcesso: payload.rotinaMonitoramentoProcesso,
      rotinaMonitoramentoResultado: payload.rotinaMonitoramentoResultado,
      planoCuidadoCompartilhado: payload.planoCuidadoCompartilhado,
      matriciamento: payload.matriciamento,
      carteiraServicoCompartilhada: payload.carteiraServicoCompartilhada,
      carteiraServicoDivulgada: payload.carteiraServicoDivulgada,
      teleMonitoramento: payload.teleMonitoramento,
      usoTics: payload.usoTics,
      pesquisaCliente: payload.pesquisaCliente,
      pesquisaPosAtendimento: payload.pesquisaPosAtendimento,
      pesquisaBeneficiario: payload.pesquisaBeneficiario,
      planoEstruturado: payload.planoEstruturado,
      modalidadeBeneficio: payload.modalidadeBeneficio,
      modalidadeIntercambio: payload.modalidadeIntercambio,
      pacienteEquipe: payload.pacienteEquipe
    };

    return {
      clickSwitch: {
        ...clickSwitches
      },
      pesquisaMetodologia: payload.pesquisaMetodologia,
      pesquisaTopicos: payload.pesquisaTopicos,
      matriciamentoEspecialidades: payload.matriciamentoEspecialidades
    };
  },
  getDadosRedeAssistencial: state => {
    const payload = state.payloadServidorAps;

    if (!payload) return null;
    if (Object.keys(payload).length == 0) return null;

    const clickSwitches = {
      realizouTreinamentoAps: payload.realizouTreinamentoAps,
      redeEspecialistaAps: payload.redeEspecialistaAps,
      ocorreAgendamentoAps: payload.ocorreAgendamentoAps,
      existeFluxoEncaminhamento: payload.existeFluxoEncaminhamento,
      existeFluxoAtendimentoAps: payload.existeFluxoAtendimentoAps,
      equipeResultadoExames: payload.equipeResultadoExames,
      equipeResultadoImagens: payload.equipeResultadoImagens,
      fluxoAtencaoDomiciliar: payload.fluxoAtencaoDomiciliar,
      fluxoAtendimentoMulti: payload.fluxoAtendimentoMulti,
      remuneracaoDiferenciadaAps: payload.remuneracaoDiferenciadaAps
    };

    return {
      clickSwitch: {
        ...clickSwitches
      },
      remuneracaoDiferenciadaObs: payload.remuneracaoDiferenciadaObs,
      redeEspecialistaApsCriterio: payload.redeEspecialistaApsCriterio
    };
  },
  getDadosLinhas: state => {
    const payload = state.payloadServidorAps;

    if (!payload) return null;
    if (Object.keys(payload).length == 0) return null;

    const clickSwitches = {
      linhaAdolescentes: payload.linhaAdolescentes,
      linhaAdultos: payload.linhaAdultos,
      linhaCriancas: payload.linhaCriancas,
      linhaGravidez: payload.linhaGravidez,
      linhaIdosos: payload.linhaIdosos,
      linhaPatologia: payload.linhaPatologia,
      linhaSaudeBucal: payload.linhaSaudeBucal,
      linhaSaudeFuncional: payload.linhaSaudeFuncional,
      linhaSaudeMental: payload.linhaSaudeMental
    };

    return {
      clickSwitch: {
        ...clickSwitches
      },
      linhaPatologiaObs: payload.linhaPatologiaObs
    };
  },
  getDadosCaracteristicasAps: state => {
    const payload = state.payloadServidorAps;

    if (!payload) return null;
    if (Object.keys(payload).length == 0) return null;

    return {
      modalidades: {
        numeroVidasProduto: payload.numeroVidasProduto,
        numeroVidasBeneficio: payload.numeroVidasBeneficio,
        numeroVidasIntercambio: payload.numeroVidasIntercambio,
        numeroVidasTotal: payload.numeroVidasTotal
      },
      clickSwitch: {
        atendeParticular: payload.atendeParticular,
        atendeConvenios: payload.atendeConvenios,
        disponibilizaIntercambio: payload.disponibilizaIntercambio,
        disponibilizaAps: payload.disponibilizaAps,
        produto: payload.produto
      },
      objetoObs: {
        atendeParticularObs: payload.atendeParticularObs,
        atendeConveniosObs: payload.atendeConveniosObs,
        disponibilizaIntercambioObs: payload.disponibilizaIntercambioObs,
        nomeProduto: payload.nomeProduto,
        codigoProduto: payload.codigoProduto
      },
      destinado: payload.destinado
    };
  },
  getDadosCaracteristicasSingular: state => {
    const payload = state.payloadServidorAps;

    if (!payload) return null;
    if (Object.keys(payload).length == 0) return null;

    return {
      numeroVidas: payload.numeroVidas,
      notaIdss: payload.notaIdss,
      notaIdqs: payload.notaIdqs,
      porteSingular: payload.porteSingular
    };
  },
  getDadosUnidadesCliente: state => {
    const payloadUnidades = state.payloadCliente.unidades;

    if (!payloadUnidades) return null;

    payloadUnidades.forEach(unidade => {
      Object.keys(unidade).forEach(function(key) {
        if (!unidade[key]) {
          unidade[key] = "";
        }
      });
    });

    return payloadUnidades;
  },
  getDadosInfoResponsavelCliente: state => {
    if (!state.payloadCliente) return null;

    return {
      nomeUnimed: state.payloadCliente.nomeUnimed,
      nomePessoa: state.payloadCliente.nomePessoa,
      telefoneNumero: state.payloadCliente.telefoneNumero,
      email: state.payloadCliente.email,
      cargo: state.payloadCliente.cargo,
      dataPreenchimento: state.payloadCliente.dataPreenchimento
    };
  },
  getDadosResponsavelApsCliente: state => {
    if (!state.payloadCliente) return null;

    return {
      nomeDiretor: state.payloadCliente.nomeDiretor,
      emailDiretor: state.payloadCliente.emailDiretor
    };
  },
  getDadosRefContrarefCliente: state => {
    const payload = state.payloadCliente;

    if (!payload) return null;
    if (Object.keys(payload).length == 0) return null;

    const clickSwitches = {
      padraoPreenchimento: payload.padraoPreenchimento,
      informatizadoCompleto: payload.informatizadoCompleto,
      informatizadoParcial: payload.informatizadoParcial,
      manual: payload.manual
    };

    return {
      clickSwitch: {
        ...clickSwitches
      },
      padraoPreenchimentoExclusivo: payload.padraoPreenchimentoExclusivo,
      informatizadoCompletoObs: payload.informatizadoCompletoObs,
      informatizadoParcialObs: payload.informatizadoParcialObs,
      manualExclusivoAps: payload.manualExclusivoAps,
      padraoPreenchimentoObs: payload.padraoPreenchimentoObs
    };
  },
  getDadosLinhasCliente: state => {
    const payload = state.payloadCliente;

    if (!payload) return null;
    if (Object.keys(payload).length == 0) return null;

    const clickSwitches = {
      linhaAdolescentes: payload.linhaAdolescentes,
      linhaAdultos: payload.linhaAdultos,
      linhaCriancas: payload.linhaCriancas,
      linhaGravidez: payload.linhaGravidez,
      linhaIdosos: payload.linhaIdosos,
      linhaPatologia: payload.linhaPatologia,
      linhaSaudeBucal: payload.linhaSaudeBucal,
      linhaSaudeFuncional: payload.linhaSaudeFuncional,
      linhaSaudeMental: payload.linhaSaudeMental
    };

    return {
      clickSwitch: {
        ...clickSwitches
      },
      linhaPatologiaObs: payload.linhaPatologiaObs
    };
  },
  getDadosProcessosUnidadeCliente: state => {
    const payload = state.payloadCliente;

    if (!payload) return null;
    if (Object.keys(payload).length == 0) return null;

    const clickSwitches = {
      termoCompromisso: payload.termoCompromisso,
      fluxoAtendimentoExpontaneo: payload.fluxoAtendimentoExpontaneo,
      criteriosCarteiraMedico: payload.criteriosCarteiraMedico,
      criteriosCarteiraEnfermeiro: payload.criteriosCarteiraEnfermeiro,
      pacientesNaoReconhecidos: payload.pacientesNaoReconhecidos,
      existeDescricoesComposicoes: payload.existeDescricoesComposicoes,
      existeProcessoPopulacional: payload.existeProcessoPopulacional,
      temProtocolosClinicos: payload.temProtocolosClinicos,
      reunioesClinicas: payload.reunioesClinicas,
      reunioesAdministrativas: payload.reunioesAdministrativas,
      rotinaMonitoramentoProcesso: payload.rotinaMonitoramentoProcesso,
      rotinaMonitoramentoResultado: payload.rotinaMonitoramentoResultado,
      planoCuidadoCompartilhado: payload.planoCuidadoCompartilhado,
      matriciamento: payload.matriciamento,
      carteiraServicoCompartilhada: payload.carteiraServicoCompartilhada,
      carteiraServicoDivulgada: payload.carteiraServicoDivulgada,
      teleMonitoramento: payload.teleMonitoramento,
      usoTics: payload.usoTics,
      pesquisaCliente: payload.pesquisaCliente,
      pesquisaPosAtendimento: payload.pesquisaPosAtendimento,
      pesquisaBeneficiario: payload.pesquisaBeneficiario,
      planoEstruturado: payload.planoEstruturado,
      modalidadeBeneficio: payload.modalidadeBeneficio,
      modalidadeIntercambio: payload.modalidadeIntercambio,
      pacienteEquipe: payload.pacienteEquipe
    };

    return {
      clickSwitch: {
        ...clickSwitches
      },
      pesquisaMetodologia: payload.pesquisaMetodologia,
      pesquisaTopicos: payload.pesquisaTopicos,
      matriciamentoEspecialidades: payload.matriciamentoEspecialidades
    };
  },
  getDadosRedeAssistencialCliente: state => {
    const payload = state.payloadCliente;

    if (!payload) return null;
    if (Object.keys(payload).length == 0) return null;

    const clickSwitches = {
      realizouTreinamentoAps: payload.realizouTreinamentoAps,
      redeEspecialistaAps: payload.redeEspecialistaAps,
      ocorreAgendamentoAps: payload.ocorreAgendamentoAps,
      existeFluxoEncaminhamento: payload.existeFluxoEncaminhamento,
      existeFluxoAtendimentoAps: payload.existeFluxoAtendimentoAps,
      equipeResultadoExames: payload.equipeResultadoExames,
      equipeResultadoImagens: payload.equipeResultadoImagens,
      fluxoAtencaoDomiciliar: payload.fluxoAtencaoDomiciliar,
      fluxoAtendimentoMulti: payload.fluxoAtendimentoMulti,
      modalidadeUnimed: payload.modalidadeUnimed
    };

    return {
      clickSwitch: {
        ...clickSwitches
      },
      remuneracaoDiferenciadaAps: payload.remuneracaoDiferenciadaAps,
      // remuneracaoDiferenciadaApsFormato: payload.modalidadeUnimed,
      redeEspecialistaApsCriterio: payload.redeEspecialistaApsCriterio
    };
  },
  getDadosCaracteristicasApsCliente: state => {
    const payload = state.payloadCliente;

    if (!payload) return null;
    if (Object.keys(payload).length == 0) return null;

    return {
      modalidades: {
        numeroVidasProduto: payload.numeroVidasProduto,
        numeroVidasBeneficio: payload.numeroVidasBeneficio,
        numeroVidasIntercambio: payload.numeroVidasIntercambio,
        numeroVidasTotal: payload.numeroVidasTotal
      },
      clickSwitch: {
        atendeParticular: payload.atendeParticular,
        atendeConvenios: payload.atendeConvenios,
        disponibilizaIntercambio: payload.disponibilizaIntercambio,
        disponibilizaAps: payload.disponibilizaAps,
        produto: payload.produto
      },
      objetoObs: {
        atendeParticularObs: payload.atendeParticularObs,
        atendeConveniosObs: payload.atendeConveniosObs,
        disponibilizaIntercambioObs: payload.disponibilizaIntercambioObs,
        nomeProduto: payload.nomeProduto,
        codigoProduto: payload.codigoProduto
      },
      destinado: payload.destinado
    };
  },
  getDadosCaracteristicasSingularCliente: state => {
    const payload = state.payloadCliente;

    if (!payload) return null;
    if (Object.keys(payload).length == 0) return null;

    return {
      numeroVidas: payload.numeroVidas,
      notaIdss: payload.notaIdss,
      notaIdqs: payload.notaIdqs,
      porteSingular: payload.porteSingular
    };
  }
};
